<template>
  <div class="attendance-abnormal-panel">
    <div class="panel-toolbar">
      <el-form :inline="true" size="medium" :model="searchCondition">
        <el-form-item>
          <el-input
            v-model.trim="searchCondition.keyword"
            placeholder="搜索申请人、申请任务"
            clearable
            style="width: 180px;"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchCondition.apply_status"
            placeholder="审批状态"
            clearable
            style="width: 120px;"
          >
            <el-option label="待审批" :value="0" />
            <el-option label="已通过" :value="1" />
            <el-option label="已驳回" :value="2" />
            <el-option label="已撤销" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="searchCondition.apply_type"
            placeholder="申请类型"
            clearable
            style="width: 120px;"
          >
            <el-option label="补卡" :value="1" />
            <el-option label="请假" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleReset">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="exportLoading" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-table
      :data="tableRows"
      border
      size="small"
      v-loading="loadingStatus"
      class="abnormal-table"
      header-cell-class-name="abnormal-table__header"
    >
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column label="序号" width="70" align="center">
        <template slot-scope="scope">
          {{ (paging.currentPage - 1) * paging.pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="user_name" label="申请人" min-width="90" />
      <el-table-column prop="mission_name" label="申请任务" min-width="120" />
      <el-table-column prop="shift_time_text" label="打卡时段" min-width="110" />
      <el-table-column prop="apply_type_text" label="申请类型" min-width="100" />
      <el-table-column prop="apply_status_text" label="审批状态" min-width="90" />
      <el-table-column prop="submit_time" label="提交时间" min-width="160" />
      <el-table-column label="操作" width="90" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-wrap">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="paging.currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="paging.pageSize"
        :total="paging.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
const PAGE_STATE_KEY = "attendance_abnormal_panel_state";
const REFRESH_FLAG_KEY = "attendance_clock_record_refresh_abnormal_list";
const DEFAULT_SEARCH_CONDITION = {
  keyword: "",
  apply_status: "",
  apply_type: "",
};
const DEFAULT_PAGING = {
  currentPage: 1,
  pageSize: 20,
  total: 0,
};

export default {
  name: "AttendanceAbnormalPanel",
  data() {
    return {
      loadingStatus: false,
      exportLoading: false,
      searchCondition: this.getDefaultSearchCondition(),
      paging: this.getDefaultPaging(),
      tableRows: [],
    };
  },
  mounted() {
    if (!this.restorePageState()) {
      this.fetchList();
      return;
    }
    if (this.consumeRefreshFlag()) {
      this.fetchList();
    }
  },
  beforeDestroy() {
    this.savePageState();
  },
  methods: {
    consumeRefreshFlag() {
      const flag = window.sessionStorage.getItem(REFRESH_FLAG_KEY);
      if (flag === "1") {
        window.sessionStorage.removeItem(REFRESH_FLAG_KEY);
        return true;
      }
      return false;
    },
    getDefaultSearchCondition() {
      return { ...DEFAULT_SEARCH_CONDITION };
    },
    getDefaultPaging() {
      return { ...DEFAULT_PAGING };
    },
    savePageState() {
      window.sessionStorage.setItem(
        PAGE_STATE_KEY,
        JSON.stringify({
          searchCondition: this.searchCondition,
          paging: this.paging,
          tableRows: this.tableRows,
        }),
      );
    },
    restorePageState() {
      const raw = window.sessionStorage.getItem(PAGE_STATE_KEY);
      if (!raw) return false;
      try {
        const state = JSON.parse(raw);
        this.searchCondition = state.searchCondition || this.getDefaultSearchCondition();
        this.paging = state.paging || this.getDefaultPaging();
        this.tableRows = Array.isArray(state.tableRows) ? state.tableRows : [];
        return true;
      } catch (_) {
        void _;
        window.sessionStorage.removeItem(PAGE_STATE_KEY);
        return false;
      }
    },
    normalizeTableRows(list = []) {
      return Array.isArray(list)
        ? list.map((item) => ({
            ...item,
            shift_time_text: item.shift_time_text || item.work_time_text || "",
          }))
        : [];
    },
    buildListParams() {
      const params = {
        current_page: this.paging.currentPage,
        page_size: this.paging.pageSize,
      };
      if (this.searchCondition.keyword) {
        params.keyword = this.searchCondition.keyword.trim();
      }
      if (this.searchCondition.apply_status !== "" && this.searchCondition.apply_status != null) {
        params.apply_status = this.searchCondition.apply_status;
      }
      if (this.searchCondition.apply_type !== "" && this.searchCondition.apply_type != null) {
        params.apply_type = this.searchCondition.apply_type;
      }
      return params;
    },
    async fetchList() {
      this.loadingStatus = true;
      try {
        const res = await this.$api.checkInApplyList(this.buildListParams());
        const pages = res.pages || {};
        this.tableRows = this.normalizeTableRows(res.list);
        this.paging.total = pages.total || 0;
        this.paging.currentPage = pages.current_page || this.paging.currentPage;
        this.savePageState();
      } catch (_) {
        void _;
        this.tableRows = [];
        this.paging.total = 0;
      } finally {
        this.loadingStatus = false;
      }
    },
    handleSearch() {
      this.paging.currentPage = 1;
      this.fetchList();
    },
    handleReset() {
      this.searchCondition = this.getDefaultSearchCondition();
      this.paging.currentPage = 1;
      this.fetchList();
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        const data = await this.$api.checkInApplyExport(this.buildListParams());
        const d = data && typeof data === "object" ? data : {};
        const header = d.header;
        const rows = d.rows;
        if (!header || !rows || !rows.length) {
          this.$message.warning("暂无数据可导出");
          return;
        }
        const { export_json_to_excel } = await import("@/excel/Export2Excel");
        export_json_to_excel({
          header,
          data: rows,
          filename: "异常考勤",
          autoWidth: true,
          bookType: "xlsx",
        });
        this.$message.success("导出成功");
      } catch (_) {
        void _;
      } finally {
        this.exportLoading = false;
      }
    },
    extractApplyId(row) {
      if (row && row.id) return String(row.id);
      if (row && row.action_url) {
        const match = String(row.action_url).match(/\/([^/]+)$/);
        return match ? match[1] : "";
      }
      return "";
    },
    handleView(row) {
      const id = this.extractApplyId(row);
      if (!id) {
        this.$message.warning("缺少申请单 ID");
        return;
      }
      this.$router.push({
        path: "/attendanceApplyAudit",
        query: { id },
      });
    },
    handleSizeChange(size) {
      this.paging.pageSize = size;
      this.paging.currentPage = 1;
      this.fetchList();
    },
    handleCurrentChange(page) {
      this.paging.currentPage = page;
      this.fetchList();
    },
    refreshByTabSwitch() {
      this.fetchList();
    },
  },
};
</script>

<style lang="scss" scoped>
.attendance-abnormal-panel {
  .panel-toolbar {
    margin-bottom: 16px;
  }

  .abnormal-table {
    margin-bottom: 16px;
  }

  .pagination-wrap {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
